import { Component,  ElementRef, ViewChild, Renderer2, Input } from '@angular/core';
import {SvcServices} from '../../services/svc.service';
import {DomSanitizer} from '@angular/platform-browser';
//import { StorageService } from '@citi-gcg-173875/citi-utils';
import { Router } from '@angular/router';
import { ContentService } from '../../services/content.service';
import { ChatbotService } from '../common-component/service/chatbot.service';
import { windowService } from '../../services/window.service';

@Component({
  selector: 'svc-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  constructor(private _svcService: SvcServices,
    private _contentService: ContentService,
    private chatbotService: ChatbotService,
    //private _storageService: StorageService,
    private router: Router,
    private el:ElementRef,
    private santi: DomSanitizer,
    private _renderer: Renderer2,
    private _window: windowService) { }

  paramDetails: any;
  siteMapLink: string;
  currentLanguage:any="en_us";
  showLanguageConfirmation:boolean = false;
  isAuthendicated:boolean = true;
  creditFAQUrl:string;
  creditFAQEligible: boolean = false;
  isMILAccount: boolean = false;
  
  @ViewChild('toggleButton') langButton;
  @Input() branding: any;
  @Input() pageData: any
    
  toggleDisclaimer(){
    this.showLanguageConfirmation=!this.showLanguageConfirmation;
  }

  // actual reloading of page logic
  switchingLanguage() {
    this.switchSiteLocale();
    if (this.isCovaConfigEnabled()) {
      this.chatbotService.chatBotDestroy();
    }


    this.closeConfirmation();
  }

  switchSiteLocale() {
    if(localStorage.getItem("siteLocal_ID")) {
      let currentLocal = this.getCurrentSiteLocale();
      if((currentLocal == 'en_US') && this._svcService.getSiteId().toLowerCase() != "cacn_homedepot"){
        localStorage.setItem("siteLocal_ID",'es_US');
      }
      else if((currentLocal == 'en_US' || currentLocal == 'en_CA' ) && this._svcService.getSiteId().toLowerCase() === "cacn_homedepot"){
        localStorage.setItem("siteLocal_ID",'fr_CA');
      }  else if(currentLocal == 'es_US') {
        localStorage.setItem("siteLocal_ID",'en_US');
      }
      else if(currentLocal == 'fr_CA') {
        localStorage.setItem("siteLocal_ID",'en_CA');
      }
    }
    this.reloadCurrentRoute();
  }
  
  ngAfterViewInit() {
    if(this.getCurrentSiteLocale()) {   
    this.creditFAQUrl="/RSag/disputesfaq?pageName=credit_bureau_disputes_faq&siteId="+ this._svcService.getSiteId() +"&langId=" + this.getCurrentSiteLocale();
    } else {
    this.creditFAQUrl="/RSag/disputesfaq?pageName=credit_bureau_disputes_faq&siteId="+ this._svcService.getSiteId();
    }
    this._svcService.productIdContactUs.subscribe((value)=>{
      if(this.branding && this.branding.copy$$enable_MIL && this.branding.copy$$enable_MIL.TEXT === 'true'){
        if(this.getCurrentSiteLocale()) {  
    	this.creditFAQUrl="/RSag/disputesfaq?pageName=credit_bureau_disputes_faq&siteId="+ this._svcService.getSiteId() +"&langId=" + this.getCurrentSiteLocale();
    	} else {
    	this.creditFAQUrl="/RSag/disputesfaq?pageName=credit_bureau_disputes_faq&siteId="+ this._svcService.getSiteId();
    	}
        if(value === 'MIL'){
          this.creditFAQUrl=this.creditFAQUrl + "&product=" + "MIL";
        }
        if(value === 'DLOC'){
          this.creditFAQUrl=this.creditFAQUrl + "&product=" + "DLOC";
        }
      }
      
  });
  setTimeout(() => {
    if(this.branding && this.branding?.copy$$credit_report_dispute_faq_eligible && this.branding.copy$$credit_report_dispute_faq_eligible?.TEXT) {
      this.creditFAQEligible = this.branding
      && this.branding.copy$$credit_report_dispute_faq_eligible
      && this.branding.copy$$credit_report_dispute_faq_eligible.TEXT 
      && (this.branding.copy$$credit_report_dispute_faq_eligible.TEXT === 'true') ? true : false;
      console.log("this.creditFAQEligible == ", this.creditFAQEligible );
    }    
  }, 1);
  console.log("this.creditFAQEligible2 == ", this.creditFAQEligible );
    this._svcService.languageSuppressMIL.subscribe((value)=>{
        if(value === true){
          this.isMILAccount = true;
        }
        if(value === false){
          this.isMILAccount = false;
        }
    });
    this.languageToggleSuppress();
  }
  
  languageToggleSuppress(){
    if(this.branding && this.branding.copy$$enable_MIL && this.branding.copy$$enable_MIL.TEXT === 'true') {
      if(this._window.nativeWindow?.dataLayer?.brandId && this._window.nativeWindow?.dataLayer?.brandId?.toUpperCase() === "MIL"){
        this.isMILAccount = true;
      }
    }
  }

  reloadCurrentRoute(){
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams['langId'] = this.getCurrentSiteLocale();
    let url = this.router.createUrlTree([window.location.pathname], {queryParams : urlTree.queryParams}).toString();
    setTimeout(()=>{
        window.location.href = url;
    },250);
  }

  getCurrentSiteLocale(){
    return localStorage.getItem("siteLocal_ID") ? localStorage.getItem("siteLocal_ID") : "en_US";
  }

  // closing X button on confirmation
  closeConfirmation() {
    this.showLanguageConfirmation=false;
  }

  isCovaConfigEnabled(){

    if ((this.pageData
      && this.pageData.config$$cfg_cw_app_client_settings
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_reactive
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_reactive.includes(this._svcService.getSiteId()))){
       console.log('Cova config is enabled');
       return true;
     } else {
       console.log('Cova config is disabled');
       return false;
     }

  }
}
